import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ApiService } from '../../../web-services/api/api.service';
import { ApiQuery } from '../../../web-services/api/api.query';
import { TranslatePipe } from '@ngx-translate/core';
import { RTLDivDirectiveDirective } from '../../../directives/rtldiv-directive.directive';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-confirm-password',
  imports: [TranslatePipe,RTLDivDirectiveDirective,FormsModule,CommonModule],
  templateUrl: './confirm-password.html',
  styleUrl: './confirm-password.scss',
})
export class ConfirmPassword {
  showResetApproval: boolean = false;
  passwordMatchFlag: boolean = false;
  @Input() token:any;
  @Output() showHideConfirmModal = new EventEmitter<any>();
  @Output() openSuccessModal = new EventEmitter<any>();

  password = '';
  confirmPassword = '';

  token_expired : boolean = false;
  token_not_exist : boolean = false;
  password_error : boolean = false; 

  constructor(private apiService:ApiService,private apiQuery:ApiQuery) { }

  ngOnInit() {
    this.passwordMatchFlag = false;
    this.apiQuery.updatedPassword$.subscribe((updatedPassword) => {
			if (!updatedPassword || updatedPassword == 0) return;
      if (updatedPassword == 1) {
        this.token_expired = false;
        this.token_not_exist = false;
        this.password_error = false; 
        this.openSuccessModal.emit(true);
        this.closeModal();
			}else if(updatedPassword == 2){
        this.token_expired = true;
        this.token_not_exist = false;
        this.password_error = false; 
      }else if(updatedPassword == 3){
        this.token_expired = false;
        this.token_not_exist = true;
        this.password_error = false; 
      }else if(updatedPassword == 4){
        this.token_expired = false;
        this.token_not_exist = false;
        this.password_error = true; 
      }
    });
  }
  public closeModal = () => {
    this.passwordMatchFlag = false;
    this.password = "";
		this.confirmPassword = "";
    this.showHideConfirmModal.emit(false);
  }
  
  sendNewPassword = (password: string, confirmPassword: string) => {
    if (password === confirmPassword) {
      this.passwordMatchFlag = false;
      const dataToSend = {
        "token": this.token,
        "new_password": password
      }
      this.apiService.updateUserPassword(dataToSend);
    }
    else {
      this.passwordMatchFlag = true;
    }
  }
}
